import { AxiosResponse } from "axios"
import { StdResponse, coreAxios } from "@/declare/api/axios"
import { FIleUploadObj } from "../interface/file-upload"

export function downloadMinioFile(objectName: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/objects`, {
        params: {
            objectName: `${objectName}`,
            ...params,
        },
        responseType: 'blob',
    })
}

export function getPresignedPutObjectUrl(objectName: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/objects/upload/url`, {
        params: {
            objectName: `${objectName}`,
            ...params,
        },
    })
}

export function checkFileExists(md5: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/files/exists/${md5}`, {
        params: params,
    })
}

export function deleteFileByMd5(md5: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/files/md5/${md5}`, {
        params: params,
    })
}


export function addOriginFile(file: FIleUploadObj, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/files`, file, {
        params: params,
    })
}

export function getFileUrlByMd5(md5: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/files/md5/${md5}`, {
        params: {
            ...params,
        }
    })
}


export function getFileUrl(objectName: string, bucketName: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/objects/url`, {
        params: {
            objectName: `${objectName}`,
            bucketName: `${bucketName}`,
            ...params,
        }
    })
}


/**
 * 上传文件
 * @param file Blob文件
 * @param fileName 文件的名字，你可以根据需要修改
 * @param params 
 * @returns 
 */
export function uploadFile(file: Blob, fileName: string, params?: {}): Promise<AxiosResponse<any>> {
    // 创建一个 FormData 对象
    const formData = new FormData();
    formData.append('file', file, fileName); // 
    return coreAxios.post(`/objects`, formData, {
        params: {
            ...params,
        }
    })
}




/**
 * 上传wav文件
 * @param file wav文件的Blob文件
 * @param fileName 文件的名字，你可以根据需要修改
 * @param params 
 * @returns 
 */
export function uploadWavFile(file: Blob, fileName: string, params?: {}): Promise<AxiosResponse<any>> {
    // 创建一个 FormData 对象
    const formData = new FormData();
    formData.append('file', file, fileName); // 
    return coreAxios.post(`/objects/wav`, formData, {
        params: {
            ...params,
        }
    })
}


export function downloadPresignedFile(objectName: string, bucketName: string, filename: string, suffix: string) {

    getFileUrl(objectName, bucketName).then(res => {

        let url = res.data;
        if (url == null) return;
        // console.log(url)
        return getBlob(url)

    }).then((blob: any) => {
        let link = document.createElement("a");
        link.style.display = 'none'
        let href = window.URL.createObjectURL(blob);
        let downloadName = `${filename}${suffix || ''}`;
        link.setAttribute('href', href);
        // link.setAttribute('download', downloadName);
        link.download = downloadName
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

//     const blob = new Blob([res.data]);
//     let link = document.createElement("a");
//     let href = window.URL.createObjectURL(blob);
//     let filename = `${file.name}${file.suffix || ''}`;
//     link.setAttribute('href', href);
//     link.setAttribute('download', filename);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(href);
function getBlob(url) {
    return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
            if (xhr.status === 200) {
                resolve(xhr.response)
            }
        }
        xhr.onprogress = (e) => {
            console.log(e);
        }
        xhr.send()
    })
}

